import {Component, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {IDialogComponent} from "../../../../modules/common/dialog/iDialog.component";
import {FileItem} from "ng2-file-upload";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DialogWithInput} from "../../../../modules/common/dialog/dialogWithInput";
import {DialogModule} from "../../../../modules/common/dialog/dialog.module";
import {ExpandedCardModule} from "../../expanded-card/expanded-card.module";
import {FileUploadModule} from "../file-upload.module";
import {FormFieldModule} from "../../../../modules/core/component/form-field/form-field.module";
import {FileUploadComponent} from "../file-upload.component";
import {ButtonModule} from "../../../../modules/core/component/button/button.module";

export interface FileUploadDialogInput {
  nbMaxFiles?: number;
  allowedFileExtensions: string[];
  maxSizeInMo?: number;
}

export interface FileUploadDialogOutput {
  files: FileItem[];
}

@Component({
  selector: 'app-file-upload-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ExpandedCardModule, FileUploadModule, FormFieldModule, ButtonModule],
  templateUrl: './file-upload-dialog.component.html',
  styles: [
  ]
})
export class FileUploadDialogComponent implements IDialogComponent<FileUploadDialogInput, FileUploadDialogOutput>{
  dialog: DialogWithInput<FileUploadDialogInput, FileUploadDialogOutput>;
  formGroup: FormGroup;
  fileItems: FileItem[] = [];
  @ViewChild('fileUpload', { static: true }) fileUploadComponent: FileUploadComponent;

  constructor(private formBuilder: FormBuilder) {
    this.formGroup = formBuilder.group({
      file: this.formBuilder.control(undefined)
    });
  }

  fileAdded(fileItem: FileItem) {
    if (fileItem && fileItem.file) {
      this.fileItems.push(fileItem);
    }
  }

  close() {
    this.dialog.close({
      files: this.fileItems,
    });
  }
}
